import Typography from "antd/lib/typography";
import clsx from "clsx";
import React, { memo, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@sol/uikit/general/Button/Button";

import { simplonWebsiteUrl } from "../../../constants/externalLinks";

type LoginLayoutHeroProps = { className?: string; brandLogo?: ReactNode; partnerLogo?: ReactNode };

const LoginLayoutHero = ({ className, brandLogo, partnerLogo }: LoginLayoutHeroProps) => {
    const [t] = useTranslation();

    return (
        <div className={clsx("relative flex w-full flex-col", className)}>
            {brandLogo}

            <div className="-mt-ant-xs -mr-ant-xs flex flex-col gap-ant-xxs xl:mb-ant-xxl">
                <Typography.Title className="mt-ant hidden text-color-ant xl:inline-block" level={1}>
                    <span className="block text-left opacity-80">{t("layout.login.heroIntroduction")}</span>
                </Typography.Title>
                <Button
                    size="small"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={simplonWebsiteUrl}
                    variant="solid"
                    className="self-end rounded-full border-transparent! bg-[#00313C]! px-ant! text-white! hover:bg-[#00313C]/90!"
                >
                    <span>{t("page.login.hero.poweredBy")}</span>
                    <img
                        src="/static/logo-light-typo.png"
                        alt="Simplonline"
                        className="mt-[-0.55em] -ml-ant-xxs h-[1.6em]"
                    />
                </Button>
            </div>

            {partnerLogo}
        </div>
    );
};

export default memo(LoginLayoutHero);
